import { createDateLocales } from '@integrations/date-setup'

export const dateLocales = createDateLocales(['en', 'en-US', 'es', 'ja', 'hr', 'pl', 'pt'])
